import {useEffect, useState} from "react";
import Avatar from "@mui/material/Avatar";
import CardMedia from "@mui/material/CardMedia";

/**
 * Imagem de projeto partilhada (portais de associações e engenheiros).
 *
 * Decisão do utilizador: sem imagem = sem imagem.
 * Se o projeto não tem imagem, ou se a URL da imagem falhar ao carregar
 * (404 / 403 / URL apagada), simplesmente não mostramos a imagem —
 * não usamos nenhum placeholder.
 */
function useProjectImage(src) {
    const [broken, setBroken] = useState(false);
    // Se a URL mudar (ex.: reutilização do componente), volta a tentar.
    useEffect(() => {
        setBroken(false);
    }, [src]);
    return {
        visible: Boolean(src) && !broken,
        hide: () => setBroken(true),
    };
}

/** Imagem no topo dos cartões de projeto (listas). */
export function ProjectCardMedia({src, alt, height = "140"}) {
    const {visible, hide} = useProjectImage(src);
    if (!visible) return null;
    return (
        <CardMedia
            component="img"
            height={height}
            image={src}
            alt={alt || "Imagem do projeto"}
            onError={hide}
        />
    );
}

/** Avatar circular de projeto (páginas de detalhe / listas de perfil). */
export function ProjectAvatar({src, alt, size = 48}) {
    const {visible, hide} = useProjectImage(src);
    if (!visible) return null;
    return (
        <Avatar
            src={src}
            sx={{width: size, height: size, flexShrink: 0}}
            imgProps={{
                alt: alt || "Imagem do projeto",
                onError: hide,
            }}
        />
    );
}
